import styles from './HomePage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import profileImg from 'assets/images/img-meher-razdan.png';
import pin from 'assets/images/profile-pin.svg';
import idIcon from 'assets/images/id-icon.svg';
import welcome from 'assets/images/welcome-art.svg';
import phone from 'assets/images/phone-blue.svg';
import calender from 'assets/images/calendar-blue.svg';

import { ProfileBar } from 'views/components/profile-bar/ProfileBar';
import { Transfer } from '../common/transfer/Transfer';
import { Rates } from '../common/rates/Rates';
import { RecentTranscation } from '../common/recent-transcation/Recent-Transcation';
import { commonActions } from '../../stores/_actions';

function HomePage() {
  const history = useHistory();
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };

  const dispatch = useDispatch();

  useEffect(() => {
    !sessionId ? history.push('/') : history.push('/home');
    dispatch(commonActions.getCustDetailsByCode(payload));
    localStorage.removeItem('transfer');
    localStorage.removeItem('iskycenabled');
  }, []);

  let userProfile = useSelector((state) => state.getCustDetails.data);

  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <div className={styles.pageLeft__welcome}>
                <div className={styles.pageLeft__welcomeContent}>
                  <div style={{ fontWeight: 'bold', color: 'darkblue', marginBottom: '6px' }}>WELCOME</div>
                  <h1>
                    <img src={userProfile?.ProfImage} alt="" />
                    {/* {userProfile && userProfile.ProfileImage ? <img src={userProfile.ProfileImage} alt="" /> : <img src={profileImg} alt="" />} */}
                    {userProfile && userProfile.FirstName + ' ' + userProfile.MiddleName + ' ' + userProfile.LastName}
                  </h1>
                  <p>
                    <img src={idIcon} alt="" />
                    ID: {userProfile && userProfile.IDNo}
                  </p>
                  {userProfile && userProfile.Addr1 ? (
                    <p>
                      <img src={pin} alt="" />
                      {userProfile && `${userProfile.Addr1} ${userProfile.Addr2}`}
                    </p>
                  ) : (
                    ''
                  )}
                  {/* {userProfile && userProfile.Addr2 ? (
                    <p>
                      <img src={pin} alt="" />
                      Address2: {userProfile && userProfile.Addr2}
                    </p>
                  ) : (
                    ''
                  )} */}
                  <p>
                    <img src={phone} alt="" />
                    MOBILE NUMBER: +{userProfile && userProfile.MobileNo}
                  </p>
                  <p>
                    <img src={calender} alt="" />
                    DATE OF BIRTH: {userProfile && userProfile.DOB}
                  </p>
                </div>
                <img className={styles.pageLeft__welcomeImg} src={welcome} alt="" />
              </div>
              <div className={styles.pageLeft__transferRates}>
                <Transfer />
                <Rates />
              </div>
            </div>
            <RecentTranscation />
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { HomePage };
